module.exports = __webpack_public_path__ + "prod/1.42.2/img/pain-4.499cee31.svg";